import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { inject, provideAppInitializer } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TitleStrategy, provideRouter } from '@angular/router';
import { OrchestratorService } from '@services/orchestrator/orchestrator.service';
import { PageTitleStrategy } from '@services/router/page-title-strategy/page-title-strategy.class';
import { ThemeService } from '@services/theme/theme.service';
import { NavigationService } from '@services/view/navigation-service/navigation.service';
import { AuthInterceptorService } from '@shared/interceptors/auth-interceptor-service';
import { RequestTrackerInterceptor } from '@shared/interceptors/request-tracker.interceptor';
import { register as registerSwiperElements } from 'swiper/element/bundle';

import { AppComponent } from './app/app.component';
import { appRoutes } from './routes/app.routes';

/// <reference types="@angular/localize" />

registerSwiperElements();

bootstrapApplication(AppComponent, {
  providers: [
    provideAppInitializer(() => {
      const theme_svc: ThemeService = inject(ThemeService);
      theme_svc.initialize();

      const nav_svc: NavigationService = inject(NavigationService);
      nav_svc.initialize();

      const orch_svc: OrchestratorService = inject(OrchestratorService);
      orch_svc.initialize();
    }),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(appRoutes),
    {
      provide: TitleStrategy,
      useClass: PageTitleStrategy
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestTrackerInterceptor,
      multi: true
    }
  ]
}).catch((err) => console.error(err));
